import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/company/sku/`;

const getSkus = async () => {
    return await axios.get(API_URL);
};


const addSku = async (categoryData) => {
    return await axios.post(API_URL, categoryData);
};

const editSku = async (categoryId, updatedData) => {
    return await axios.put(API_URL + categoryId, updatedData);
};

const deleteSku = async (categoryId) => {
    return await axios.delete(API_URL + categoryId);
};

export default {
  getSkus,
  addSku,
  editSku,
  deleteSku,
};
